import React from 'react';
import { SectionPlaceholder } from '../Placeholders/SectionPlaceholder';
import { ItemCardPlaceholder } from '../Placeholders/ItemCardPlaceholder';

interface SkeletonLoadersProps {
  loading?: boolean;
  noHeader?: boolean;
  rowCount?: number;
}

export const SkeletonLoaders: React.FC<SkeletonLoadersProps> = ({
  loading = true,
  noHeader = false,
  rowCount = 1
}) => {
  if (!loading) return null;
  return (
    <SectionPlaceholder isCardsLayout noHeader={noHeader} rowCount={rowCount}>
      {Array.from({ length: 4 }, (_, index) => (
        <ItemCardPlaceholder key={index} isCardsLayout />
      ))}
    </SectionPlaceholder>
  );
};
